import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { SESSION_OPTIONS } from "../../../constants/sessions";

const StudentUpdateForm = () => {
  const navigate = new useNavigate();
  const { id } = useParams(); // Get the student ID from the URL
  const [formData, setFormData] = useState({
    student_name: "",
    class_roll_number: "",
    dob: "",
    aadhar_number: "",
    student_class: "",
    admission_number: "",
    date_of_admission: "",
    session: "",
    category: "",
    blood_group: "",
    mother_tongue: "",
    nationality: "",
    father_name: "",
    contact_number_father: "",
    father_occupation: "",
    mother_name: "",
    contact_number_mother: "",
    mother_occupation: "",
    email: "",
    address: "",
    police_station: "",
    post_office: "",
    district: "",
    state: "Jharkhand",
    pincode: "",
    expelled: "",
    siblings_in_school: "",
    siblings_name_class: "",
    declaration: false,
    admission_fees_paid: false,
    transportation: "",
  });

  useEffect(() => {
    // Fetch student data to pre-fill the form
    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setFormData(response.data); // Set the form data with the fetched student details
        } else {
          toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching student data.");
      }
    };

    fetchStudentData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (
      name === "expelled" ||
      name === "siblings_in_school" ||
      name === "transportation"
    ) {
      setFormData({
        ...formData,
        [name]: value === "true", // Convert "true"/"false" to boolean
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/student/update/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Student updated successfully!");
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          navigate(
            `/erp/students/details/class/${formData.student_class}/${formData.student_id}`
          );
        }, 2000);
      } else {
        toast.error("Failed to update student. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please check your input and try again.");
    }
  };

  const categories = ["GEN", "OBC", "SC", "ST"];
  const classes = [
    "PRE-NURSERY",
    "NURSERY",
    "LKG",
    "UKG",
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ];
  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link
              to={`/erp/students/details/class/${formData.student_class}`}
              className="btn btn-secondary mb-3"
            >
              &#8592; Back to Class List
            </Link>
            <h3 className="text-center text-success d-flex justify-content-between align-items-start ">
              Update Student Information
            </h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>Student ID - {id}</h5>
          </div>
        </div>
        <form onSubmit={handleUpdate}>
          {/* Row 1 */}
          <div className="row g-3 ">
            <h4 className="mt-3">Student Details</h4>
            <div className="col-md-4">
              <label className="form-label">Name of Student *</label>
              <input
                type="text"
                className="form-control"
                name="student_name"
                value={formData.student_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Class Roll Number</label>
              <input
                type="text"
                className="form-control"
                name="class_roll_number"
                value={formData.class_roll_number}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Class for Admission *</label>
              <select
                className="form-control"
                name="student_class"
                value={formData.student_class}
                onChange={handleChange}
                required
              >
                <option value="">Select Class</option>
                {classes.map((cls, index) => (
                  <option key={index} value={cls}>
                    {typeof cls === "number" ? `Class ${cls}` : cls}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* Row 2 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Gender *</label>
              <select
                className="form-control"
                name="gender"
                value={formData.gender === null ? "" : formData.gender} // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Birth *</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Aadhar Number</label>
              <input
                type="text"
                className="form-control"
                name="aadhar_number"
                value={formData.aadhar_number}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Admission Number *</label>
              <input
                type="text"
                className="form-control"
                name="admission_number"
                value={formData.admission_number}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Admission *</label>
              <input
                type="date"
                className="form-control"
                name="date_of_admission"
                value={formData.date_of_admission}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Session *</label>
              <select
                className="form-control"
                name="session"
                value={formData.session}
                onChange={handleChange}
                required
              >
                <option value="">Select Session</option>
                {SESSION_OPTIONS.map((session) => (
                  <option key={session} value={session}>
                    {session}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* Row 4 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Category *</label>
              <select
                className="form-control"
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Blood Group</label>
              <input
                type="text"
                className="form-control"
                name="blood_group"
                value={formData.blood_group}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Mother Tongue *</label>
              <input
                type="text"
                className="form-control"
                name="mother_tongue"
                value={formData.mother_tongue}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 5 */}
          <div className="row g-3 mt-4">
            <div className="col-md-4">
              <label className="form-label">Nationality *</label>
              <input
                type="text"
                className="form-control"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          {/* Row 6 */}
          <div className="row g-3 mt-4">
            <h4 className="mt-3">Parents Details</h4>
            <div className="col-md-4">
              <label className="form-label">Father&apos;s Name *</label>
              <input
                type="text"
                className="form-control"
                name="father_name"
                value={formData.father_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Father&apos;s Contact Number *
              </label>
              <input
                type="text"
                className="form-control"
                name="contact_number_father"
                value={formData.contact_number_father}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Father's Occupation *</label>
              <input
                type="text"
                className="form-control"
                name="father_occupation"
                value={formData.father_occupation}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 7 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Mother&apos;s Name *</label>
              <input
                type="text"
                className="form-control"
                name="mother_name"
                value={formData.mother_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Mother&apos;s Contact Number</label>
              <input
                type="text"
                className="form-control"
                name="contact_number_mother"
                value={formData.contact_number_mother}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Mother's Occupation *</label>
              <input
                type="text"
                className="form-control"
                name="mother_occupation"
                value={formData.mother_occupation}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 8 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 9 */}
          <div className="row g-3 mt-3">
            <h4 className="mt-2">Address and Other Details</h4>
            <div className="col-md-4">
              <label className="form-label">Address *</label>
              <input
                type="text"
                className="form-control"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Police Station *</label>
              <input
                type="text"
                className="form-control"
                name="police_station"
                value={formData.police_station}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Post Office *</label>
              <input
                type="text"
                className="form-control"
                name="post_office"
                value={formData.post_office}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 10 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">District *</label>
              <input
                type="text"
                className="form-control"
                name="district"
                value={formData.district}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">State *</label>
              <input
                type="text"
                className="form-control"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
                disabled
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Pin Code *</label>
              <input
                type="number"
                className="form-control"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                required
                maxLength={6}
              />
            </div>
          </div>
          {/* Row 11 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">
                Whether Expelled in Previous School ? *
              </label>
              <select
                className="form-control"
                name="expelled"
                value={formData.expelled === null ? "" : formData.expelled} // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Whethter Transportation Opted ? *
              </label>
              <select
                className="form-control"
                name="transportation"
                value={
                  formData.transportation === null
                    ? ""
                    : formData.transportation
                } // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">
                Any Siblings Studying in School *
              </label>
              <select
                className="form-control"
                name="siblings_in_school"
                value={
                  formData.siblings_in_school === null
                    ? ""
                    : formData.siblings_in_school
                } // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          {/* Conditional rendering for Relative Name */}
          <div className="row g-3 mt-3">
            {formData.siblings_in_school && (
              <div className="col-md-4">
                <label className="form-label">
                  Siblings's Name and Class *
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="siblings_name_class"
                  value={formData.siblings_name_class}
                  onChange={handleChange}
                  required
                />
              </div>
            )}
          </div>
          {/* Declaration Checkbox */}
          <div className="mt-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name="declaration"
                checked={formData.declaration}
                onChange={handleChange}
                required
              />
              <label className="form-check-label">
                I declare that all the information is correct.
              </label>
            </div>
          </div>

          {/* Update Button */}
          <div className="d-flex justify-content-center mt-4">
            <div className="d-grid gap-2">
              <button
                type="submit"
                className="btn btn-success"
                disabled={!formData.declaration}
              >
                Update Student
              </button>
            </div>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default StudentUpdateForm;
